import React from 'react';
import { InputLabel, InputLabelProps } from '@mui/material';
import styled from 'styled-components';
import { colors } from 'spw-theme';

const StyledLabel = styled(InputLabel)`
  background-color: ${({ $backgroundColor }: { $backgroundColor?: string }) =>
    $backgroundColor ?? colors.white};
  margin-left: -5px;

  &.MuiFormLabel-root {
    padding: 0 5px;
  }
`;

const SelectShrunkenLabel = (
  props: Omit<InputLabelProps, 'shrink'> & { $backgroundColor?: string }
) => {
  return <StyledLabel {...props} shrink />;
};

export default SelectShrunkenLabel;
